/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shift_Word_Forward_TitleInputs */

const en_shift_word_forward_title = /** @type {(inputs: Shift_Word_Forward_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shift Word Down`)
};

const fr_shift_word_forward_title = /** @type {(inputs: Shift_Word_Forward_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decaler le Mot en Bas`)
};

const de_shift_word_forward_title = /** @type {(inputs: Shift_Word_Forward_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wort nach unten verschieben`)
};

const it_shift_word_forward_title = /** @type {(inputs: Shift_Word_Forward_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sposta parola verso il basso`)
};

const ru_shift_word_forward_title = /** @type {(inputs: Shift_Word_Forward_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сдвинуть слово вниз`)
};

const es_shift_word_forward_title = /** @type {(inputs: Shift_Word_Forward_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplazar palabra hacia abajo`)
};

const zh_cn2_shift_word_forward_title = /** @type {(inputs: Shift_Word_Forward_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向下移动单词`)
};

const ja_shift_word_forward_title = /** @type {(inputs: Shift_Word_Forward_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単語を下へシフト`)
};

const hi_shift_word_forward_title = /** @type {(inputs: Shift_Word_Forward_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शब्द को नीचे ले जाएं`)
};

const pt_pt2_shift_word_forward_title = /** @type {(inputs: Shift_Word_Forward_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desloque a palavra para baixo`)
};

/**
* | output |
* | --- |
* | "Shift Word Down" |
*
* @param {Shift_Word_Forward_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shift_word_forward_title = /** @type {((inputs?: Shift_Word_Forward_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shift_Word_Forward_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shift_word_forward_title(inputs)
	if (locale === "de") return de_shift_word_forward_title(inputs)
	if (locale === "it") return it_shift_word_forward_title(inputs)
	if (locale === "ru") return ru_shift_word_forward_title(inputs)
	if (locale === "es") return es_shift_word_forward_title(inputs)
	if (locale === "zh-CN") return zh_cn2_shift_word_forward_title(inputs)
	if (locale === "ja") return ja_shift_word_forward_title(inputs)
	if (locale === "hi") return hi_shift_word_forward_title(inputs)
	if (locale === "pt-PT") return pt_pt2_shift_word_forward_title(inputs)
	return en_shift_word_forward_title(inputs)
});